import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = '__st';

export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearToken = () => { localStorage.removeItem(TOKEN_KEY); sessionStorage.removeItem(TOKEN_KEY); };
const getToken = () => localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

// Attach Bearer token for all requests
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isOAuthCallback = window.location.hash?.includes('session_id=') || window.location.pathname === '/auth/callback';
      const isAuthRoute = window.location.pathname === '/login';
      const isAuthEndpoint = error.config?.url?.includes('/auth/');
      if (!isOAuthCallback && !isAuthRoute && !isAuthEndpoint) {
        clearToken();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export const BACKEND_URL = API_URL;

export const getErrorMessage = (err, fallback = 'Something went wrong') => {
  const detail = err.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(d => d.msg || JSON.stringify(d)).join(', ');
  return fallback;
};
